<template>
  <div class="container app-container">
    <el-form :inline="true" ref="search" :model="search" class="demo-form-inline">
      <el-form-item prop="name">
        <el-input v-model="search.name" placeholder="请输入护士"></el-input>
      </el-form-item>
      <el-form-item prop="tel">
        <el-input v-model="search.tel" placeholder="请输入护士手机号"></el-input>
      </el-form-item>
      <el-form-item prop="address">
        <el-select v-model="search.address" placeholder="请选择村镇">
          <el-option v-for="option in nurseAddressList" :key="option.id" :label="option.name"
                     :value="option.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="status">
        <el-select v-model="search.status" placeholder="护士状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="停用" value="0"></el-option>
          <el-option label="启用" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleAddNurse">添加护工</el-button>
        <el-button type="primary" @click="searchData">查询</el-button>
        <el-button @click="resetForm('search')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      max-height="600"
      stripe
    >
      <el-table-column
        type="index"
        label="序号"
        width="50">
        <template slot-scope="{$index}"> {{ $index + ((page_number - 1) * page_size ) + 1 }}</template>
      </el-table-column>
      <el-table-column prop="name" label="护工姓名" align="center" />
      <el-table-column prop="tel" label="手机号" align="center" />
      <el-table-column prop="status" label="护工状态" align="center">
        <template slot-scope="{ row }">
          {{ row.status | toNurseStatusText }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="村镇" align="center">
        <template slot-scope="{ row: { address }}">
          {{ address }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="添加时间" align="center" />
      <el-table-column label="停启用">
        <template slot-scope="{ row: { status, id }}">
          <div @click="changeStatus(id, status)">
            <el-switch :value="status === 1"></el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="{ row }">
          <i class="el-icon-tickets fz24" title="详情" @click="handleEditNurse(row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page_size"
        :current-page="page_number"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <EditNurse ref="editNurse" @update="getList" />
  </div>
</template>

<script>
import { fetchNurseSList } from '@/api'
import { formatDate } from 'element-ui/lib/utils/date-util'
import EditNurse from './components/EditNurse'
import { editNurse, fetchNurseAddressList } from '../../api'
export default {
  name: 'NurseManagement',
  components: { EditNurse },
  data() {
    return {
      search: {
        name: '',
        tel: '',
        address: '',
        status: ''
      },
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      total: 0,
      nurseAddressList: [],
      tableData: [],
    }
  },
  filters: {
    formatDate,
    toNurseStatusText(val) {
      return {
        '0': '停用',
        '1': '启用'
      }[val] || '-'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    changeStatus(id, status) {
      const params = {
        id,
        status: status === 1 ? 0 : 1
      }
      editNurse(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.init()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    init() {
      // status 0 超级管理员 1无权限 2有权限 默认1无权限
      this.getNurseAddressList()
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page_number = 1
      this.getList()
    },
    getNurseAddressList() {
      fetchNurseAddressList().then(res =>  {
        if (res.status) {
          this.nurseAddressList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleAddNurse() {
      this.$refs.editNurse.handleOpen()
    },
    handleEditNurse(nurse) {
      this.$refs.editNurse.handleOpen(nurse)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    getList() {
      this.tableLoading = true
      const { page_size, page_number, search } = this
      const { ...searchInfo } = search
      const params = {
        page_size: page_size,
        page_number: page_number,
        ...searchInfo
      }
      this.tableLoading = true
      fetchNurseSList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    width: 100%;

    .imgbox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .litimg {
        width: 30px;
        height: 30px;
        margin: 3px;
        object-fit: cover;
        cursor: zoom-in;
      }
    }

    .picture {
      width: 100%;
    }

    .block {
      text-align: center;
    }

    .el-pagination {
      margin-top: 20px;
    }

    .total {
      padding: 0 6% 15px;
      color: #26A4B2;
      text-align: right;
      font-weight: bold;
    }
  }
</style>
